import React from 'react';
import { SvgIcon } from '@mui/material';

export function MtsLogo(props) {
  return (
    <SvgIcon
      sx={{ width: '200px', height: '64px', viewBox: '0 0 200px 64px' }}
      {...props}
      viewBox="0 0 200 64"
      fill="none"
    >
      <svg
        width="200"
        height="64"
        viewBox="0 0 200 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11733_38827)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.3788 12.562C33.5076 12.562 30.1035 15.3224 27.2956 19.963C24.3689 24.7692 22.623 30.7191 22.623 35.886C22.623 43.4502 26.8679 51.0784 36.3796 51.0784C45.8799 51.0784 50.1362 43.4502 50.1362 35.886C50.1362 30.7191 48.391 24.7692 45.4786 19.963C42.6443 15.3224 39.2406 12.562 36.3788 12.562ZM110.661 23.9108H120.29V49.0157H130.608V23.9108H140.233V14.6243H110.661V23.9096V23.9108ZM162.244 23.9108H177.376V14.6243H162.244C148.342 14.6243 140.917 21.5364 140.917 31.8188C140.917 42.1013 148.342 49.0157 162.244 49.0157H177.376V39.7296H162.244C155.81 39.7296 151.58 37.4299 151.58 31.82C151.58 26.2101 155.81 23.9108 162.244 23.9108ZM89.676 14.6243L84.1773 35.1511L78.6786 14.6243H60.4532V49.0157H70.7667V21.0427L78.262 49.0157H90.0926L97.5919 21.0258V49.0157H107.909V14.6243H89.676Z"
            fill="#E30613"
          />
        </g>
        <defs>
          <clipPath id="clip0_11733_38827">
            <rect
              width="154.809"
              height="38.5164"
              fill="white"
              transform="translate(22.5957 12.562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
